import Vue from 'vue';

// EventBus is a way to communicate between two components in vue that are not a parent and child, meaning they
// are not used one inside the other. it is used a few times in this project by importing from this file
const EventBus = new Vue();

export default EventBus;